 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_NEAL_COVER from '@/components/00_Neal_cover'
 import LOVE_1 from '@/components/love_1'
 import A1A_NEAL_HT from '@/components/01a_Neal_ht'
 import A1B_NEAL_FT from '@/components/01b_Neal_ft'
 import NOTICE from '@/components/notice'
 import A1C_NEAL_CIP from '@/components/01c_Neal_cip'
 import A1D_NEAL_CONTENTS from '@/components/01d_Neal_contents'
 import A1E_NEAL_PREFACE from '@/components/01e_Neal_preface'
 import A1F_NEAL_ACK from '@/components/01f_Neal_ack'
 import A2_NEAL_PT1 from '@/components/02_Neal_pt1'
 import A3_NEAL_1 from '@/components/03_Neal_1'
 import A4_NEAL_2 from '@/components/04_Neal_2'
 import A5_NEAL_3 from '@/components/05_Neal_3'
 import A6_NEAL_4 from '@/components/06_Neal_4'
 import A7_NEAL_5 from '@/components/07_Neal_5'
 import A8_NEAL_6 from '@/components/08_Neal_6'
 import A9_NEAL_PT2 from '@/components/09_Neal_pt2'
 import A0_NEAL_7 from '@/components/10_Neal_7'
 import A1_NEAL_8 from '@/components/11_Neal_8'
 import A2_NEAL_9 from '@/components/12_Neal_9'
 import A3_NEAL_10 from '@/components/13_Neal_10'
 import A4_NEAL_11 from '@/components/14_Neal_11'
 import A5_NEAL_12 from '@/components/15_Neal_12'
 import A0_NEAL_ART from '@/components/00_Neal_art'
 import A6_NEAL_PT3 from '@/components/16_Neal_pt3'
 import A7_NEAL_13 from '@/components/17_Neal_13'
 import A8_NEAL_14 from '@/components/18_Neal_14'
 import A9_NEAL_15 from '@/components/19_Neal_15'
 import A0_NEAL_16 from '@/components/20_Neal_16'
 import A1_NEAL_17 from '@/components/21_Neal_17'
 import A2_NEAL_PT4 from '@/components/22_Neal_pt4'
 import A3_NEAL_18 from '@/components/23_Neal_18'
 import A4_NEAL_19 from '@/components/24_Neal_19'
 import LOVE_2 from '@/components/love_2'
 import A5_NEAL_NOTES from '@/components/25_Neal_notes'
 import A6_NEAL_BIBLIO from '@/components/26_Neal_biblio'
 import A7_NEAL_INDEX from '@/components/27_Neal_index'
 import COPY from '@/components/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/01d_Neal_contents",
 			"name" : "01d_Neal_contents",
 			"component" : A1D_NEAL_CONTENTS
 		},
 		{
 			"path" : "/01e_Neal_preface",
 			"name" : "01e_Neal_preface",
 			"component" : A1E_NEAL_PREFACE
 		},
 		{
 			"path" : "/01f_Neal_ack",
 			"name" : "01f_Neal_ack",
 			"component" : A1F_NEAL_ACK
 		},
 		{
 			"path" : "/02_Neal_pt1",
 			"name" : "02_Neal_pt1",
 			"component" : A2_NEAL_PT1
 		},
 		{
 			"path" : "/03_Neal_1",
 			"name" : "03_Neal_1",
 			"component" : A3_NEAL_1
 		},
 		{
 			"path" : "/04_Neal_2",
 			"name" : "04_Neal_2",
 			"component" : A4_NEAL_2
 		},
 		{
 			"path" : "/05_Neal_3",
 			"name" : "05_Neal_3",
 			"component" : A5_NEAL_3
 		},
 		{
 			"path" : "/06_Neal_4",
 			"name" : "06_Neal_4",
 			"component" : A6_NEAL_4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js